import JSONAPISerializer from '@ember-data/serializer/json-api';

export default class GdprConfigurationSerializer extends JSONAPISerializer {}
